import {useDispatch, useSelector} from "react-redux";
import Modal from "react-bootstrap/Modal";
import {Col, Row, Spinner} from "react-bootstrap";
import Alert from "react-bootstrap/Alert";
import Dropdown from "../../../../primer/Dropdown";
import {greekMonthOptions} from "../../Payroll/Components/constants";
import Input from "../../../../common/Input";
import Button from "react-bootstrap/Button";
import React, {useEffect, useState} from "react";
import moment from "moment";
import axios from "axios";
import {toast} from "react-toastify";
import {getGreekCurrencyFormat, isEmpty} from "../../../../../_helpers/commonFunctions";
import {setCorrelatedVisitData} from "../../../../../_reducers/DataPanel/Sales/salesSlice";
import {ADA_OPTIONS, CONSTANT_ADA, CONSTANT_ANATHETOUSA} from "../Data/constants_eopyy";
import {greekMonthsSecondFormat} from "../constants";
import {openNewSale} from "../../../../../_helpers/tabOpeners";

const B2GVisitsModal = ({show, setShow}) => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const SALES_SETTINGS = useSelector((state) => state.SALES_SETTINGS);
    const [loading, setLoading] = useState(false);
    const [requestData, setRequestData] = useState({
        month: moment().subtract(1, "month").format("MM"),
        year: String(company.year),
    })
    const [responseData, setResponseData] = useState({});
    const [settings, setSettings] = useState({});

    const [selectedADA, setSelectedADA] = useState(CONSTANT_ADA);

    useEffect(() => {
        if (!isEmpty(settings?.lastSelectedADA)) setSelectedADA(settings.lastSelectedADA);
    }, [settings]);

    const handleSale = () => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/onboard-auto-invoice`, {
            company: company.id,
            selectedADA: selectedADA,
        }).then((res) => {
            if (res.data.status === "200") {
                const corVisitData = {
                    documentType: res.data.documentType,
                    documentTypeName: res.data.documentTypeName,
                    autoSaleProduct: settings.autoSaleProduct,
                    autoSaleProductQuantity: responseData.count,
                    client: res.data.client,
                    peppol: {
                        projectReference: selectedADA,
                        partyIdentification: CONSTANT_ANATHETOUSA,
                        contractDocumentReference: "0",
                        paymentMethodInfo: "Επί Πιστώσει",
                        buyerReference: `EDAPY-${responseData.submissionNumber}-${responseData.contractNumber}`,
                        dueDate: moment().format("YYYY-MM-DD"),
                    },
                    notes: `Επισκέψεις ασφαλισμένων ΕΟΠΥΥ μηνός ${greekMonthsSecondFormat[requestData.month]} ${requestData.year}`,
                }
                const paymentTypes = SALES_SETTINGS.salesGeneralSettings.paymentTypes;
                const findCreditPaymentType = paymentTypes.find((el) => el.myDataPaymentId === "5");
                if (findCreditPaymentType) {
                    corVisitData.paymentType = findCreditPaymentType._id;
                    corVisitData.paymentTypeName = findCreditPaymentType.name;
                }
                dispatch(setCorrelatedVisitData(corVisitData));
                dispatch(openNewSale(TABS_DATA));
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleFetchVisits = () => {
        setResponseData({});
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/my-executed-visits`, {
            company: company.id,
            ...requestData,
        }, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            if (res.data.status === "200") {
                setResponseData(res.data.data);
                setSettings(res.data.settings);
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            console.log(err);
            setLoading(false);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const successfulResponse = Object.keys(responseData).length > 0;

    return (
        <React.Fragment>
            <Modal show={show} backdrop={"static"} onHide={() => setShow(false)} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Τιμολόγηση ολοκληρωμένων επισκέψεων προς ΕΟΠΥΥ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <Alert variant={"secondary"}>
                                Παρακαλώ επιλέξτε τον μήνα που θέλετε να γίνει η άντληση σύμβασης. Η σύμβαση θα πρέπει να έχει εκδοθεί αλλά να μην έχει καταχωρηθεί.
                                Αμέσως μετά την επιτυχής άντληση θα εμφανιστούν παρακάτω τα στοιχεία της καθώς και ένα κουμπί το οποίο πατώντας το, θα σας μεταβιβάσει
                                στην σελίδα της νέας πώλησης με προσυμπληρωμένα τα περισσότερα στοιχεία που απαιτούνται για την τιμολόγηση σας.
                            </Alert>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <Dropdown
                                name={"month"}
                                label={"Μήνας"}
                                options={greekMonthOptions}
                                defaultValue={greekMonthOptions.find((el) => el.value === requestData.month)}
                                key={Math.random()}
                                onChange={(e) => {
                                    setResponseData({});
                                    setRequestData({...requestData, month: e.value});
                                }}
                            />
                        </Col>
                        <Col md={3}>
                            <Input
                                name={"year"}
                                label={"Έτος"}
                                disabled={true}
                                value={requestData.year}
                            />
                        </Col>
                        <Col md={3}>
                            <div style={{marginTop: "18px"}}>
                                <Button size={"sm"} className={"mt-2"} onClick={() => handleFetchVisits()} disabled={loading} style={{height: "36px", width: "100%"}}>
                                    Άντληση ολοκλ. επισκέψεων {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                    {successfulResponse && (
                        <React.Fragment>
                            <div className={"border-top pt-2"}>
                                <div>Βρέθηκε επιτυχώς η μηνιαία σας σύμβαση για τις ιατρικές επισκέψεις του συμβεβλημένου ιατρείου σας προς τον ΕΟΠΥΥ.</div>
                                <Row className={"mt-3"}>
                                    <Col md={3}>
                                        <Dropdown
                                            name={"selectedADA"}
                                            label={"Α.Δ.Α."}
                                            options={ADA_OPTIONS}
                                            key={selectedADA}
                                            defaultValue={ADA_OPTIONS.find((el) => el.value === selectedADA)}
                                            onChange={(e) => setSelectedADA(e.value)}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Input
                                            name={"submissionNumber"}
                                            label={"Αριθμός Υποβολής"}
                                            value={responseData.submissionNumber}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Input
                                            name={"contractNumber"}
                                            label={"Αριθμός / Περιγραφή Σύμβασης"}
                                            value={responseData.contractNumber}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Input
                                            name={"count"}
                                            label={"Αριθμός Επισκέψεων"}
                                            value={responseData.count}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Input
                                            name={"netValue"}
                                            label={"Τελικό ποσό"}
                                            value={getGreekCurrencyFormat(responseData.netValue)}
                                            disabled={true}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShow(false)}>
                        Κλείσιμο
                    </Button>
                    {successfulResponse && (
                        <Button variant="primary" onClick={() => handleSale()}>
                            Προς πώληση
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default B2GVisitsModal;
